import React from "react";
import AccountVerificationCheckForm from "./AccountVerificationCheckForm";
import get from "lodash/get";
import Modal from "../../common/components/modules/modal/Modal";
import {ModalBackButton} from "../../common/components/modules/modal/modalComponents";

function AccountVerificationCheckModal({
  title,
  titleComponent,
  submitLabel,
  onSuccess,
  location,
  defaultPhone,
  defaultEmail,
  extraInfo,
  isOpen,
  closeModal,
  backAction,
  replaceOnClose,
  identityVerificationId,
}) {
  const urlParams = new URLSearchParams(get(location, "search"));
  const phone = urlParams.get("phone") || defaultPhone;
  const email = urlParams.get("email") || defaultEmail;

  return (
    <Modal isOpen={isOpen} onRequestClose={closeModal} replaceOnClose={replaceOnClose}>
      <ModalBackButton onClick={() => backAction()} />
      <AccountVerificationCheckForm
        title={title}
        submitLabel={submitLabel}
        titleComponent={titleComponent}
        phoneNumber={phone}
        email={email}
        extraInfo={extraInfo}
        identityVerificationId={identityVerificationId}
        onPhoneVerificationCheckSuccessful={onSuccess}
      />
    </Modal>
  );
}

export default AccountVerificationCheckModal;
